<template>
<div class="page-container-v2">
    <a-spin :spinning="loading" :tip="$t('common_loading')">
        <page-header
            :title="$t('productslist_header_title')"
            :sub-title="$t('productslist_header_desc')"
        >
            <template #rightArea>
                <div class="page-header-right-area">

                </div>
            </template>
        </page-header>
        <div class="card-body px-0 pt-0 pb-2 table-with-search">
            <div class="search-filter-container table-info-filter">
                <div class="search-filter-row">
                    <div class="search-filter-title">
                        {{ $t('productslist_search_condition') }}
                    </div>
                    <div class="search-filter-content">
                        <div class="mobile-wrap">
                            <a-select 
                                v-model:value="searchFilter" 
                                style="width: 180px"
                                size="small"
                                :placeholder="$t('common_searchfilter_select')"
                            >
                                <a-select-option 
                                    v-for="option in searchFilterOptions" 
                                    :key="option.value" 
                                    :value="option.value"
                                >
                                    {{ option.label }}
                                </a-select-option>
                            </a-select>
                            <a-input 
                                size="small"
                                style="width: 400px; margin: 0 8px;"
                                v-model:value="condition"
                                @keyup.enter="enter"
                                :placeholder="$t('productslist_search_placeholder')"
                            />
                            <a-button 
                                size="small"
                                class="black"
                                @click="enter" 
                                style="margin-right: 8px;"
                            >
                                {{ $t('common_searchfilter_search') }}
                            </a-button>
                            <a-button
                                size="small"
                                @click="handleReset"
                            >
                                {{ $t('common_searchfilter_reset') }}
                            </a-button>
                        </div>
                    </div>
                </div>
                <div class="search-filter-row">
                <div class="search-filter-title">
                    {{ $t('productslist_erp_register_date') }}
                </div>
                <div class="search-filter-content">
                    <div class="mobile-wrap">
                        <a-range-picker
                            v-model:value="dateRange.dates"
                            :format="'YYYY-MM-DD'"
                            :disabled-date="disabledDate"
                            @change="handleDateRangeChange"
                            style="width: 240px;"
                            :locale="antDateLocale"
                            size="small"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 table-info-filter">
                <div class="total-div">
                    <p>
                        {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                    </p>
                </div>
                <div class="search-container">
                    <a-select 
                        style="width: 150px"
                        v-model:value="rowsPerPage" 
                        @change="handleRowsPerPage"
                        size="small"
                    >
                        <a-select-option :value="10">{{ $t('common_rows_per_page_10') }}</a-select-option>
                        <a-select-option :value="20">{{ $t('common_rows_per_page_20') }}</a-select-option>
                        <a-select-option :value="50">{{ $t('common_rows_per_page_50') }}</a-select-option>
                        <a-select-option :value="100">{{ $t('common_rows_per_page_100') }}</a-select-option>
                    </a-select>
                </div>
            </div>
            <div v-if="!isMobileView">
                <a-table class="ant-table-striped"
                    size="small"
                    :columns="columns"
                    :data-source="responseData"
                    :pagination="false"
                    :scroll="{ x: 1400 }"
                    v-if="responseData.length > 0"
                >
                    <template #bodyCell="{ column, record }">
                    </template>
                </a-table>
                <div class="no-result-container" v-else>
                    <i class="fa-solid fa-exclamation-triangle" />
                    <span>{{ computedNoResultMessage }} </span>
                </div>
            </div>

            <!-- 모바일 카드뷰 -->
            <div v-else class="mobile-card-list">
                <div v-for="(record, idx) in responseData" :key="record.SerialNo || idx" class="mobile-company-card">
                    <div class="card-field">
                        <span class="card-label">{{ $t('productslist_serial_no') }}:</span>
                        <span>{{ record.SerialNo || '-' }}</span>
                    </div>
                    <div class="card-field">
                        <span class="card-label">{{ $t('productslist_product_name') }}:</span>
                        <span>{{ record.ItemName || '-' }}</span>
                    </div>
                    <div class="card-field">
                        <span class="card-label">{{ $t('productslist_product_code') }}:</span>
                        <span>{{ record.ItemNo || '-' }}</span>
                    </div>
                    <div class="card-field">
                        <span class="card-label">{{ $t('productslist_valid_date') }}:</span>
                        <span>{{ record.ValidDate || '-' }}</span>
                    </div>
                    <div class="card-field">
                        <span class="card-label">{{ $t('productslist_warranty_count') }}:</span>
                        <span>{{ record.IssueCount }}{{ $t('productslist_times') }}</span>
                    </div>
                    <div class="card-field">
                        <span class="card-label">{{ $t('productslist_erp_register_date') }}:</span>
                        <span>{{ record.LastDateTime ? formatLastDateTime(record.LastDateTime) : '-' }}</span>
                    </div>
                    <div class="card-actions">
                        <a-button size="small" @click="showQRCode(record.SerialNo)">{{ $t('common_view') }}</a-button>
                        <a-button size="small" @click="showTraceDetail(record)">{{ $t('productslist_view_trace') }}</a-button>
                        <a-button v-if="record.IssueCount > 0" size="small" type="primary" @click="goToCertificateList(record)">查看认证卡</a-button>
                        <a-button size="small" type="primary" danger @click="handleRecoverCert(record)">回收认证卡</a-button>
                    </div>
                </div>
                <div v-if="!loading && responseData.length === 0" class="no-result-container">
                    <i class="fa-solid fa-exclamation-triangle" />
                    <span>{{ computedNoResultMessage }} </span>
                </div>
            </div>
        </div>
        <pagination 
            v-if="!$store.state.isLoading && responseData.length > 0"
            :page-info="paginationData"
            page-name="ProductList"
            
            @change-page="paginationHandler"
        />
    </a-spin>
</div>
<TraceDetailModal
    :visible="traceModal.visible"
    :trace-data="traceModal.data"
    @close="closeTraceModal"
/>
<QRCodeModal
    :visible="qrModal.visible"
    :serial-no="qrModal.serialNo"
    @close="closeQRModal"
/>
</template>

<script>
import NoResult from '@/views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';
import PageHeader from '@/views/components/PageHeader.vue';
import { oneBtnDialog, formatCommaNumber } from '@/utils/utils';
import dayjs from "dayjs";
import 'dayjs/locale/zh'
import 'dayjs/locale/ko'
import TraceDetailModal from './components/TraceDetailModal.vue';
import QRCodeModal from './components/QRCodeModal.vue';
import productListApis from './api';
import chinaInapi from '@/apis/chinaInapi';
import {
    PRODUCT_SEARCH_FILTERS,
    DEFAULT_PRODUCT_SEARCH_FILTER,
    isValidProductSearchFilter,
    buildProductSearchParams,
} from './searchFilters';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue';
import Swal from 'sweetalert2';
import { antDateLocaleMixin } from '@/mixins/antDateLocaleMixin';
import dealerEcountListMixin from '@/mixins/dealerEcountListMixin';

export default {
  mixins: [antDateLocaleMixin, dealerEcountListMixin],
    name: 'ProductsList',
    components: {
        NoResult,
        Pagination,
        PageHeader,
        TraceDetailModal,
        QRCodeModal,
        QuestionCircleOutlined
    },
    data() {
        // 개발 환경인 경우 2024-01-01 ~ 2024-01-31, 그 외에는 최근 7일
        let startDate, endDate;
        if (process.env.VUE_APP_MODE === 'development') {
            startDate = dayjs('2024-01-01');
            endDate = dayjs('2024-01-07');
        } else {
            endDate = dayjs();
            startDate = endDate.subtract(7, 'day');
        }
        
        return {
            formatCommaNumber,
            apis: null,
            // 목록 받아오는 변수
            responseData: [],

            // 페이지네이션 관련 변수
            // [HARD] 라벨이 아니라 값을 넣는다. 라벨($t)을 넣으면 화면상 정상으로 보이는데
            // switch/조회가 통째로 무력화되고 날짜 필터까지 빠져 전체 목록이 결과처럼 나온다
            // (2026-08-19 운영 장애). 값은 searchFilters.js 정의에서만 파생시킨다.
            searchFilter: DEFAULT_PRODUCT_SEARCH_FILTER,
            condition: '',
            columns:[
                {
                    key: 'SerialNo', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_serial_no')}
                            <a-tooltip title={this.$t('productslist_serial_no_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'SerialNo', 
                    align: 'start',
                },
                {
                    key: 'qrCode',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_qr_code')}
                            <a-tooltip title={this.$t('productslist_qr_code_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'SerialNo',
                    align: 'center',
                    width: 80,
                    customRender: ({text}) => (
                        <a-button type="default" size="small" onClick={() => this.showQRCode(text)}>
                            {this.$t('common_view')}
                        </a-button>
                    )
                },
                {
                    key: 'ItemName', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_product_name')}
                            <a-tooltip title={this.$t('productslist_product_name_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'ItemName', 
                    align: 'start',
                },
                {
                    key: 'ItemNo', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_product_code')}
                            <a-tooltip title={this.$t('productslist_product_code_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'ItemNo', 
                    align: 'start',
                },
                {
                    key: 'LotNo', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_lot_no')}
                            <a-tooltip title={this.$t('productslist_lot_no_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'LotNo', 
                    align: 'start',
                    customRender: ({text}) => text || '-'
                },
                {
                    key: 'ValidDate', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_valid_date')}
                            <a-tooltip title={this.$t('productslist_valid_date_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'ValidDate', 
                    align: 'center',
                    customRender: ({text}) => text || '-'
                },
                {
                    key: 'traceCount', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_trace_record')}
                            <a-tooltip title={this.$t('productslist_trace_record_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'traceCount', 
                    align: 'center',
                    customRender: ({text, record}) => (
                        <a-button type="link" size="small" onClick={() => this.showTraceDetail(record)}>
                            {text === 0 ? this.$t('productslist_view_trace') : `${text}${this.$t('productslist_trace_count')}`}
                        </a-button>
                    )
                },
                {
                    key: 'IssueCount',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_warranty_count')}
                            <a-tooltip title={this.$t('productslist_warranty_count_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'IssueCount',
                    align: 'center',
                    customRender: ({text}) => {
                        const style = {
                            color: text === 0 ? '#1890ff' : 
                                   text === 1 ? '#52c41a' : 
                                   '#f5222d'
                        };
                        return <span style={style}>{`${text}${this.$t('productslist_times')}`}</span>;
                    }
                },
                {
                    key: 'LastDateTime',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_erp_register_date')}
                            <a-tooltip title={this.$t('productslist_erp_register_date_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'LastDateTime',
                    align: 'center',
                    customRender: ({text}) => {
                        return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-';
                    }
                },
                {
                    key: 'lastTrace', 
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_latest_trace')}
                            <a-tooltip title={this.$t('productslist_latest_trace_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'lastTrace', 
                    align: 'center',
                    customRender: ({text}) => {
                        if (!text) return '-';
                        return `${text.TypeName || ''} ${text.CompanyName || text.CustName || ''}`;
                    }
                },
                {
                    key: 'viewTrace',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            {this.$t('productslist_view_trace')}
                            <a-tooltip title={this.$t('productslist_view_trace_desc')}>
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'Trace',
                    align: 'center',
                    width: 100,
                    customRender: ({text, record}) => (
                        <a-button type="default" size="small" onClick={() => this.showTraceDetail(record)}>
                            {this.$t('productslist_view_trace')}
                        </a-button>
                    )
                },
                {
                    key: 'viewCertificate',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            查看认证卡
                            <a-tooltip title="查看此产品的认证卡信息">
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'viewCertificate',
                    align: 'center',
                    width: 100,
                    customRender: ({text, record}) => {
                        // IssueCount가 1 이상인 경우에만 버튼 표시
                        if (record.IssueCount && record.IssueCount > 0) {
                            return (
                                <a-button 
                                    type="primary"
                                    size="small" 
                                    onClick={() => this.goToCertificateList(record)}
                                >
                                    查看认证卡
                                </a-button>
                            );
                        }
                        return '-';
                    }
                },
                {
                    key: 'recoverCert',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            回收认证卡
                            <a-tooltip title="回收产品认证卡">
                                <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help" />
                            </a-tooltip>
                        </div>
                    ),
                    dataIndex: 'recoverCert',
                    align: 'center',
                    width: 100,
                    customRender: ({text, record}) => (
                        <a-button 
                            type="primary" 
                            danger
                            size="small" 
                            onClick={() => this.handleRecoverCert(record)}
                        >
                            回收认证卡
                        </a-button>
                    )
                }
            ],

            listSize: 0,
            rowsPerPage: 10, 
            paginationData: {
                currentPage: 1,
                totalPages: 0
            },
            // 옵션은 정의에서 파생 — 값·라벨이 어긋날 수 없다
            searchFilterOptions: PRODUCT_SEARCH_FILTERS.map((f) => ({
                value: f.value,
                label: this.$t(f.labelKey),
            })),
            dateRange: {
                dates: [startDate, endDate],
                startDate: startDate.format('YYYYMMDD'),
                endDate: endDate.format('YYYYMMDD')
            },
            maxDateRange: 30,
            traceModal: {
                visible: false,
                data: []
            },
            loading: false,
            qrModal: {
                visible: false,
                serialNo: ''
            },
        };
    },
    async created() {
        // 제품 목록/추적/회수: 한국 inapi → china-inapi 이관 (GET·PUT /products/admin/dentium/china)
        this.apis = productListApis(chinaInapi);
    },
    async mounted() {
        // 예시: /china/product-list?searchFilter=serialNo&condition=124C612449
        const { searchFilter, condition } = this.$route.query;

        // 쿼리로 들어온 검색조건은 반드시 검증한다. 검증 없이 그대로 넣으면 잘못된 값이
        // 화면상 정상처럼 보이면서 검색이 무력화된다(2026-08-19 운영 장애와 동일 증상).
        if (searchFilter) {
            if (isValidProductSearchFilter(searchFilter)) {
                this.searchFilter = searchFilter;
            } else {
                console.warn(
                    `[ProductsList] 알 수 없는 searchFilter="${searchFilter}" — 기본값으로 대체`,
                );
                this.searchFilter = DEFAULT_PRODUCT_SEARCH_FILTER;
            }
        }
        if (condition) {
            this.condition = condition;
        }
        await this.getProductsList();
    },
    
    computed: {
        computedNoResultMessage() {
            return this.searchText
                ? this.$t('productslist_search_no_result')
                : this.$t('productslist_no_data');
        },
    },
    methods: {
        // 전체 목록 가져오기
        async getProductsList(skipValidation = false) {
            try {
                this.loading = true;
                const params = this.buildSearchParams();

                // 날짜 범위 검증 (skipValidation이 true일 경우 검증 건너뛰기)
                if (!skipValidation && !this.validateDateRange()) return;

                const response = await this.apis.getProductsList(params);
                
                if (response.data.success) {
                    this.handleProductsResponse(response.data.data);
                }
            } catch (error) {
                await this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        async paginationHandler(childPassParam) {
            try {
                this.loading = true;
                if (!childPassParam || !childPassParam.page) return;
                
                this.paginationData.currentPage = childPassParam.page;
                await this.getProductsList();
            } finally {
                this.loading = false;
            }
        },
        async enter() {
            // 필터 선택 여부 먼저 체크.
            // 빈 값뿐 아니라 "값이 아닌 것"(라벨·오타·쿼리 유입값)까지 여기서 막는다.
            // 통과시키면 검색이 조용히 무력화되고 전체 목록이 결과처럼 나온다.
            if (!isValidProductSearchFilter(this.searchFilter)) {
                await oneBtnDialog(
                    this.$t('productslist_search_empty_filter_err_title'), 
                    this.$t('productslist_search_empty_filter_err_content'), 
                    false
                );
                return;
            }
            
            // 검색어 입력 여부 체크 추가
            if (!this.condition.trim()) {
                await oneBtnDialog(
                    this.$t('productslist_search_empty_keyword_err_title'),
                    this.$t('productslist_search_empty_keyword_err_content'),
                    false
                );
                return;
            }

            // 붙여넣기로 딸려온 앞뒤 공백 제거. 이 화면의 백엔드 검색은 부분일치가 아니라
            // 완전일치(admin-list-filter.ts: SerialNo/ItemNo 등가 비교)라 공백 한 칸이 곧 0건이다.
            // 내부 공백·하이픈은 건드리지 않는다 — ItemNo 는 하이픈을 정상적으로 포함하고
            // (운영 실측 20,000건 중 4,894건), 공백을 포함한 값도 23건 존재한다.
            this.condition = this.condition.trim();

            try {
                this.loading = true;
                this.paginationData.currentPage = 1;
                await this.getProductsList(true);  // 날짜 범위 검증 건너뛰기
            } finally {
                this.loading = false;
            }
        },
        async handleRowsPerPage() {
            try {
                this.loading = true;
                this.paginationData.currentPage = 1;
                await this.getProductsList();
            } finally {
                this.loading = false;
            }
        },
        // 인증서 상태 코드 텍스트로 변환
        convertCodeToText(code) {
            switch (code) {
                case 'original-unissued':
                    return this.$t('productslist_original_unissued');
                case 'original-issued':
                    return this.$t('productslist_original_issued');
                case 'customer-issued':
                    return this.$t('productslist_customer_issued');
                case 'unlimited-issued':
                    return this.$t('productslist_unlimited_issued');
                case 'hospital-issued':
                    return this.$t('productslist_hospital_issued');
                case 'dispose':
                    return this.$t('productslist_disposed');
                default:
                    return '-';
            }
        },
        // disabled date 처리를 위한 메서드 추가
        disabledDate(current) {
            return current && current > dayjs().endOf('day');
        },
        // 날짜 범위 변경 핸들러
        async handleDateRangeChange(dates, dateStrings) {
            try {
                this.loading = true;
                if (!dates || dates.length !== 2) return;

                const [start, end] = dates;
                const [startStr, endStr] = dateStrings;
                
                // 날짜 범위 검증
                const diffDays = end.diff(start, 'day');
                if (diffDays > this.maxDateRange) {
                    await oneBtnDialog(
                        this.$t('common_date_range_exceed'),
                        this.$t('common_date_range_limit'),
                        false
                    );
                    return;
                }

                // dateRange 업데이트
                this.dateRange = {
                    dates: dates,
                    startDate: startStr,
                    endDate: endStr
                };

                this.paginationData.currentPage = 1;
                await this.getProductsList();
            } finally {
                this.loading = false;
            }
        },
        async showTraceDetail(record) {
            try {
                this.loading = true;
                // ERP가 유일 소스이므로 저장된 traceCount와 무관하게 매번 재조회한다
                const response = await this.apis.getAndUpdateTraceBySerialNo(record.SerialNo);
                if (!response.data.success) {
                    // 조회 실패 시 저장된(구) 데이터로 모달을 열지 않는다
                    await oneBtnDialog(
                        '追溯信息查询失败',
                        response.data.error || 'ERP查询超时，请稍后重试。',
                        false
                    );
                    return;
                }

                // 응답 데이터로 record 업데이트
                record.Trace = response.data.data.Trace;
                record.traceCount = response.data.data.traceCount;
                record.lastTrace = response.data.data.lastTrace;

                // responseData 배열에서 해당 record 업데이트
                const index = this.responseData.findIndex(item => item.SerialNo === record.SerialNo);
                if (index !== -1) {
                    this.responseData[index] = {
                        ...this.responseData[index],
                        Trace: record.Trace,
                        traceCount: record.traceCount,
                        lastTrace: record.lastTrace
                    };
                }

                // 모달에 데이터 표시
                this.traceModal.data = record.Trace;
                this.traceModal.visible = true;
            } catch (error) {
                console.error('Error fetching trace details:', error);
                await oneBtnDialog(
                    '追溯信息查询失败',
                    'ERP查询超时，请稍后重试。',
                    false
                );
            } finally {
                this.loading = false;
            }
        },
        
        closeTraceModal() {
            this.traceModal.visible = false;
            this.traceModal.data = [];
        },
        // 검색 파라미터 생성
        buildSearchParams() {
            const params = {
                page: this.paginationData.currentPage,
                limit: this.rowsPerPage,
            };

            // [HARD] 판정 기준은 "검색 파라미터가 실제로 만들어졌는가" 하나다.
            // 예전에는 `searchFilter && condition` 만 보고 날짜 범위를 뺐는데, 검색조건 값이
            // 잘못되면 검색 파라미터는 안 실리고 날짜 필터만 빠져 전체 목록이 검색 결과처럼
            // 나왔다(2026-08-19 운영 장애). 검색이 성립하지 않으면 날짜 필터를 유지한다.
            const searchParams = buildProductSearchParams(this.searchFilter, this.condition);
            if (searchParams) {
                Object.assign(params, searchParams);
            } else {
                params.createDateStart = this.dateRange.startDate;
                params.createDateEnd = this.dateRange.endDate;
            }

            return params;
        },
        // 날짜 범위 검증
        async validateDateRange() {
            const diffDays = this.dateRange.dates[1].diff(this.dateRange.dates[0], 'day');
            if (diffDays > this.maxDateRange) {
                await oneBtnDialog(
                    '日期范围超出',
                    '最多只能查询1个月。',
                    false
                );
                return false;
            }
            return true;
        },
        // API 응답 처리
        handleProductsResponse(data) {
            const { items, paginator } = data;
            this.responseData = items;
            this.listSize = paginator.totalItems;

            this.paginationData = {
                currentPage: paginator.currentPage,
                totalPages: paginator.totalPages
            };
        },
        // 에러 처리
        async handleError(error) {
            console.error('Error fetching products:', error);
            await oneBtnDialog(
                this.$t('productslist_load_err_title'), 
                this.$t('productslist_load_err_content'), 
                false
            );
        },
        showQRCode(serialNo) {
            this.qrModal.serialNo = serialNo;
            this.qrModal.visible = true;
        },
        closeQRModal() {
            this.qrModal.visible = false;
            this.qrModal.serialNo = '';
        },
        handleReset() {
            // [HARD] 라벨($t)이 아니라 값. 초기화 버튼으로도 같은 장애가 재현됐다.
            this.searchFilter = DEFAULT_PRODUCT_SEARCH_FILTER;
            this.condition = '';
            this.paginationData.currentPage = 1;
            this.getProductsList();  // 날짜 검증 포함하여 조회
        },
        // 검색 조건 초기화
        initSearchFilter() {
            this.searchFilter = '';
            this.condition = '';
        },
        async handleRecoverCert(record) {
            console.log('handleRecoverCert called with record:', record);
            
            try {
                // Swal을 직접 사용하여 확인 대화상자 표시
                const confirmResult = await Swal.fire({
                    title: '确认回收认证卡',
                    text: `确定要回收序列号为 ${record.SerialNo} 的产品认证卡吗？`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-primary-confirm btn-hover swal-button-custom',
                        cancelButton: 'btn btn-secondary-cancel btn-hover swal-button-custom',
                    }
                });

                console.log('Confirm result:', confirmResult);

                if (confirmResult.isConfirmed) {
                    this.loading = true;
                    console.log('User confirmed, calling API for SerialNo:', record.SerialNo);
                    
                    try {
                        // API 호출 전 확인
                        if (!this.apis || !this.apis.recoverCertificate) {
                            console.error('API method not found:', this.apis);
                            throw new Error('API 메서드를 찾을 수 없습니다.');
                        }
                        
                        // API 호출
                        console.log('Calling recoverCertificate API...');
                        const response = await this.apis.recoverCertificate(record.SerialNo);
                        console.log('API response:', response);
                        
                        if (response && response.data && response.data.success) {
                            console.log('API call successful');
                            
                            // 영문 메시지를 중국어로 변환
                            let message = response.data.message || '认证卡回收成功';
                            if (message === 'Certificate recovered successfully') {
                                message = '认证卡回收成功';
                            }
                            
                            // 성공 메시지 표시
                            await Swal.fire({
                                title: '操作成功',
                                text: message,
                                icon: 'success',
                                confirmButtonText: '确认',
                                buttonsStyling: false,
                                customClass: {
                                    confirmButton: 'btn btn-primary btn-hover',
                                }
                            });
                            
                            // 목록 새로고침
                            await this.getProductsList();
                        } else {
                            console.error('API returned error:', response);
                            throw new Error(response?.data?.message || '认证卡回收失败');
                        }
                    } catch (apiError) {
                        console.error('API Error:', apiError);
                        await Swal.fire({
                            title: '操作失败',
                            text: apiError.response?.data?.message || apiError.message || '认证卡回收失败，请稍后重试',
                            icon: 'error',
                            confirmButtonText: '确认',
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: 'btn btn-primary btn-hover',
                            }
                        });
                    }
                } else {
                    console.log('User cancelled the operation');
                }
            } catch (error) {
                console.error('Error in handleRecoverCert:', error);
            } finally {
                this.loading = false;
            }
        },
        // 모바일 카드뷰 전용 — 데스크탑 컬럼(LastDateTime)과 동일한 포맷 유지(타임존 변환 없이 로컬 dayjs)
        formatLastDateTime(text) {
            return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-';
        },
        // 인증서 목록 페이지로 이동
        goToCertificateList(record) {
            this.$router.push({
                path: '/china/certificate/list',
                query: {
                    searchFilter: 'serialNo',
                    condition: record.SerialNo
                }
            });
        },
    },
};
</script>
<style lang="scss">

@media screen and (max-width:767px) {
  //개별 등록
  #productDetailWriteModal{
    padding: 20px;
    .modal-div-wrap .modal-input-div{
      flex-direction: column;
      input,
      select,
      textarea{
        width: 100% !important;
      }
    }
    .modal-div-wrap .modal-input-div .label-wrap{
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>

@media screen and (max-width:767px) {
  
  .search-container {
    gap: 8px !important;
    .search-div {
        flex-direction: row;
        gap: 0px;
        background-color: initial !important;
        select{
            width: 150px !important;
        }
        .typing-area{
            width: 100%;
            gap: 0;
        }
    }
  }

  // 제품관리 목록화면
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv{
    width: 100% !important;
  }
  .header-btn{
    margin-left: auto;
  }
  .CertListTitle {
      width: 100%;
    .d-flex.gap-2{
      width: 100%;
      flex-direction: column;
      button{
        width: 100%;
        word-break: keep-all;
        text-align: left;
      }
    }
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    align-items: flex-start;
    flex: none;
    justify-content: flex-start;
    height: 210px;
  }
  .table-with-search .search-container .search-div input,
  .table-with-search .search-container .search-div button{
    width: 60px !important;
    min-width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .table-with-search .search-container .search-div input{
    width: calc(100% - 60px)!important;
  }
  #searchFilter{
    display: flex;
    flex-wrap: row;
  }
   .table-with-search .search-container,
   .table-with-search .search-container .search-div,
   .table-with-search .search-container select{
    width: 100%;
    flex: none;
   }
}

@media screen and (min-width:768px) and (max-width:1023px){
  .header-btn{
    padding: 12px;
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }

}

/* 스핀 컴포넌트 스타일 커스터마이징 */
:deep(.ant-spin-nested-loading) {
    width: 100%;
}

:deep(.ant-spin) {
    max-height: none;
}

.date-filter {
    display: flex;
    align-items: center;
    gap: 8px;

    .filter-label {
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        font-weight: bold;
    }
}

.search-filter-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: #fafafa;
    border-radius: 4px;
    margin-bottom: 16px;
}

.search-filter-row {
    display: flex;
    align-items: flex-start;
    min-height: 32px;
}

.search-filter-title {
    width: 120px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 32px;
}

.search-filter-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.search-filter-content {
    flex: 1;
    
    .mobile-wrap {
        display: flex;
        align-items: center;
        
        .ant-select {
            .ant-select-selector {
                border-radius: 8px;
            }
        }
        
        .ant-input {
            border-radius: 8px;
            margin: 0 8px;
        }
        
        .ant-btn {
            border-radius: 8px !important;
        }
    }
}

@media screen and (max-width: 767px) {
    .search-filter-row {
        flex-direction: column;
    }
    
    .search-filter-title {
        width: 100%;
        margin-bottom: 8px;
    }
    
    .mobile-wrap {
        flex-direction: column;
        width: 100%;
        
        .ant-select,
        .ant-input {
            width: 100% !important;
            margin: 4px 0 !important;
        }
        
        .ant-btn {
            width: calc(50% - 4px);
        }
    }

    .mobile-card-list { display: flex; flex-direction: column; gap: 12px; }
    .mobile-company-card { border: 1px solid #f0f0f0; border-radius: 6px; padding: 12px; background: #fff; }
    .card-field { display: flex; gap: 8px; margin-bottom: 6px; font-size: 13px; align-items: center; }
    .card-label { font-weight: 600; min-width: 90px; flex-shrink: 0; color: #666; }
    .card-actions { display: flex; flex-wrap: wrap; gap: 6px; border-top: 1px solid #f5f5f5; padding-top: 8px; }
    .card-actions :deep(.ant-btn) { flex: 1 1 auto; }
}
</style>